import { logger } from '@fiverr-private/obs';
import { DOMAIN_ERROR_PREFIX } from './constants';

export const logAPIError = (exception = {}, enrichment = {}) => {
    const { message } = exception;

    const stackResult = {};
    Error.captureStackTrace(stackResult, logAPIError);

    logger.error(
        {
            ...exception,
            message: `${DOMAIN_ERROR_PREFIX} ${message}`,
        },
        {
            ...enrichment,
            trace: stackResult.stack,
        }
    );
};

export { DOMAIN_ERROR_PREFIX };
